module.exports = __webpack_public_path__ + "static/media/gallery (8).5f7ffc0d.jpg";